module.exports = __webpack_public_path__ + "564630ab0d53f6771aad5ce3bd4d9aee.svg";